import { Environment, TenantComplianceFormEntityType, User } from "../models";
import { find } from "lodash";
import { getEntityInEnvironment } from "./get-entity-in-environment";
import { isUserAssignedToEntity } from "./is-user-assigned-to-entity";
import { isUserTenantAdmin } from "./is-user-tenant-admin";

export function hasUserAdminAccessToEnvironmentEntity(
  environment: Environment,
  entityType: TenantComplianceFormEntityType,
  entityId: string,
  user: User,
): boolean {
  if (!user) {
    return false;
  }

  const isTenantAdmin = isUserTenantAdmin(user, environment.tenantId);
  if (isTenantAdmin) {
    return true;
  }

  const userEmail = user.email;
  const entity = getEntityInEnvironment(
    environment,
    entityType,
    entityId,
  ) as any;
  if (!entity) {
    return false;
  }
  if (isUserAssignedToEntity(entity.data, userEmail)) {
    return true;
  }
  return false;
}
